import {MessageCodes} from "../MessageCodes";
import {useAppContext} from "../../../context/AppContext";
import ResultView from "../../../components/ResultView";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import HecRasHelper from "../../../helpers/HecRasHelper";
import CheckCSName from "../CheckCSName";

// County text for a single county group, mirroring InternalSummaryPanel's
// renderCountyLine but as inline content for a table cell.
const renderCounty = (group, idx) => {
    switch (group.position) {
        case 'us':
            return (
                <div key={idx}>
                    {group.county} (US of RS <CheckCSName csName={group.rs_boundary} csNameVal={group.rs_boundary}/>)
                </div>
            )
        case 'ds':
            return (
                <div key={idx}>
                    {group.county} (DS of RS <CheckCSName csName={group.rs_boundary} csNameVal={group.rs_boundary}/>)
                </div>
            )
        case 'between':
            return (
                <div key={idx}>
                    {group.county} (between RS <CheckCSName csName={group.rs_us} csNameVal={group.rs_us}/>
                    {' '}and RS <CheckCSName csName={group.rs_ds} csNameVal={group.rs_ds}/>)
                </div>
            )
        case 'single':
        default:
            return <div key={idx}>{group.county}</div>
    }
}

export function OV1({message_key}) {
    const {getSelectedHistory} = useAppContext()
    const summary = getSelectedHistory()?.summary?.base

    const counties = summary?.counties || []
    const spatial_xy = summary?.spatial_xy
    const firmPanels = summary?.fema_firm_panels || []
    const politicalAreas = summary?.political_areas || []

    // "CITY OF WINSTON-SALEM (375360)" — cid yoksa sadece ad, ad yoksa sadece cid.
    const fmtPolitical = (a) => {
        if (a?.name && a?.cid) return `${a.name} (${a.cid})`
        return a?.name || (a?.cid ? `(${a.cid})` : '')
    }

    // Tüm satırlarda aynı sütun genişlikleri — tablo hizası diğer tablolarla tutarlı.
    const LABEL_W = HecRasHelper.getWidth(25)
    const VALUE_W = HecRasHelper.getWidth(25)

    return (
        <ResultView error_id={MessageCodes.Internal.OV01.error_id} message_key={message_key}>
            <ResultText>
                The location information of the plan is tabulated below.
            </ResultText>
            <EmptyLine/>
            <ResultTable>
                <ResultBody>
                    {counties.length > 0 && (
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: LABEL_W}}>County</ResultHeaderCell>
                            <ResultBodyCell style={{textAlign: 'right', width: VALUE_W}}>
                                {counties.map(renderCounty)}
                            </ResultBodyCell>
                        </ResultRow>
                    )}
                    {spatial_xy && spatial_xy.length === 2 && (
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: LABEL_W}}>Spatial Identifier</ResultHeaderCell>
                            <ResultBodyCell style={{textAlign: 'right', width: VALUE_W}}>({spatial_xy[0]}, {spatial_xy[1]})</ResultBodyCell>
                        </ResultRow>
                    )}
                    {firmPanels.length > 0 && (
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: LABEL_W}}>FEMA FIRM Panel</ResultHeaderCell>
                            <ResultBodyCell style={{textAlign: 'right', width: VALUE_W}}>{firmPanels.join(', ')}</ResultBodyCell>
                        </ResultRow>
                    )}
                    {politicalAreas.length > 0 && (
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: LABEL_W}}>Political Area (CID)</ResultHeaderCell>
                            <ResultBodyCell style={{textAlign: 'right', width: VALUE_W}}>
                                {politicalAreas.map((a, i) => (<div key={i}>{fmtPolitical(a)}</div>))}
                            </ResultBodyCell>
                        </ResultRow>
                    )}
                </ResultBody>
            </ResultTable>
        </ResultView>
    )
}
